{
  "loading": "Betöltés folyamatban…",
  "loadingMore": "Továbbiak betöltése folyamatban…"
}